/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React from 'react';
import { withTranslation } from 'react-i18next';

import { commonStyleForEditPersonalInfo } from '../../Common/CommonStyle';
import Loader from '../../Common/Loader';
import { hot } from 'react-hot-loader';

class BaseForm extends React.Component {
	render() {
		const { t, classes, isLoading } = this.props;
		return (
			<section>
				<Grid alignItems="center" className={classes.root} container justify="center" spacing={2}>
					<Grid
						alignItems="center"
						className={classes.root}
						item
						justify="center"
						sm={8}
						spacing={10}
						xs={8}
						style={{
							minWidth: '335px'
						}}>
						<Paper className={classes.paper}>
							<Card className={classes.root} variant="outlined">
								<Button
									onClick={this.props.closeProfileScreen}
									size="small"
									style={{ display: 'inline-block', float: 'left' }}>
									<ArrowBackIosIcon />
									{t('buttons.back_profile')}
								</Button>
								<Grid
									alignItems="center"
									className={classes.root}
									container
									justify="center"
									spacing={2}>
									<Grid alignItems="center" item justify="center" sm={10} xs={12}>
										<Grid
											alignItems="center"
											className={classes.root}
											container
											justify="center"
											spacing={2}
											style={{ padding: '0 20px' }}>
											{this.props.children}
										</Grid>
										<div className={classes.blockdiv}>
											<Fab
												aria-label="add"
												className={classes.submit}
												color="primary"
												disabled={this.props.disabled}
												onClick={this.props.onSubmitHandler}
												size="medium"
												type="submit"
												variant="extended">
												Submit &nbsp;
											</Fab>
										</div>
									</Grid>
								</Grid>
							</Card>
						</Paper>
					</Grid>
				</Grid>
				{isLoading ? <Loader /> : ''}
			</section>
		);
	}
}

export default hot(module)(withStyles(commonStyleForEditPersonalInfo)(withTranslation()(BaseForm)));
